import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';


const Footer = () => {
  return (
    <footer className="bg-slate-800 text-white py-6">
      <div className="container mx-auto px-4">
        {/* Section principale */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* À propos */}
          <div>
            <h3 className="text-lg font-bold mb-4">À propos</h3>
            <p className="text-sm text-slate-400">
              Bienvenue dans notre application SaaS, une plateforme dédiée pour vous offrir des solutions intuitives et pratiques.
            </p>
          </div>

          {/* Liens utiles */}
          <div>
            <h3 className="text-lg font-bold mb-4">Liens utiles</h3>
            <ul className="space-y-2 p-0">
              {/*
              <li>
                <a href="/about" className="text-sm text-slate-400 hover:text-white">
                  À propos de nous
                </a>
              </li>
              */}
              <li>
                <a href="/contact" className="text-sm text-slate-400 hover:text-white">
                  Contactez-nous
                </a>
              </li>
              {/*
              <li>
                <a href="/faq" className="text-sm text-slate-400 hover:text-white">
                  FAQ
                </a>
              </li>
              */}
              <li>
                <a href="/mentions-legales" className="text-sm text-slate-400 hover:text-white">
                  Mentions Légales
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-sm text-slate-400 hover:text-white">
                  Politique de confidentialité
                </a>
              </li>
              <li>
                <a href="/terms-of-service" className="text-sm text-slate-400 hover:text-white">
                  Conditions d'utilisation
                </a>
              </li>
            </ul>
          </div>

          {/* Réseaux sociaux */}
          <div>
            <h3 className="text-lg font-bold mb-4">Suivez-nous</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/jobrise-app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Section copyright */}
        <div className="text-center mt-6 text-sm text-slate-500">
          &copy; {new Date().getFullYear()} Jobrise. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
